<template>
  <main>
    <v-container class="booking-table">
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>CSR</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            to="/content/csr/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        :headers="csrsTableHeaders"
        :loading="loadingDataTable"
        :items="csrs"
        :mobile-breakpoint="zero"
        :items-per-page="200"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <v-img
                height="50px"
                width="70px"
                class="radius-12"
                v-if="item.header != null"
                :src="item ? item.header : '--'"
              ></v-img>
              <span v-else>No Logo</span>
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.title : "---" }}
            </td>

            <td class="table__cell name text-center">
              {{ item ? item.category : "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.no_of_kids_1 || "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.no_of_kids_2 || "---" }}
            </td>
            <td class="text-center">
              <v-btn
                :disabled="item.sliders.length == 5"
                icon
                @click="passSlider(item)"
                ><v-icon>mdi-image</v-icon></v-btn
              >
            </td>
            <td class="text-center">
              <v-btn
                color="primary"
                rounded
                large
                :to="`/content/csr/${item.id}/slider`"
                ><small>Images</small></v-btn
              >
            </td>
            <td class="text-center">
              <v-btn icon @click="passItem(item)"
                ><v-icon>mdi-image</v-icon></v-btn
              >
            </td>
            <td class="text-center">
              <v-btn
                color="primary"
                rounded
                large
                :to="`/content/csr/${item.id}/logos`"
                ><small>Logos</small></v-btn
              >
            </td>

            <td class="table__cell text-center">
              <router-link
                :to="{ name: 'editCsr', params: { id: item.id } }"
                class="hovering mr-1 edit"
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span @click="handleDelete(item, index)" class="hovering delete">
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title primary-title>
          Upload Logo
        </v-card-title>

        <v-card-text>
          <v-alert
            v-if="globalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in globalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
          <section class="file-upload">
            <new-image-upload
              class="file-upload__image"
              :imgUrl="form.logo ? form.logo.path : ''"
              :imgId="form.logo ? form.logo.id : ''"
              @fileSelected="logoChange"
              fieldName="mainImgFile"
              :maxSize="maxSize"
              :reset="resetBoolean"
            />
          </section>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadingImage"
            :disabled="form.logo == ''"
            @click="handleSave"
          >
            Save
          </v-btn>
          <v-btn color="error" text @click="cancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sliderDialog" width="500">
      <v-card>
        <v-card-title primary-title>
          Upload Slide
        </v-card-title>

        <v-card-text>
          <v-alert
            v-if="globalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in globalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
          <section class="file-upload">
            <new-image-upload
              class="file-upload__image"
              :imgUrl="form.slider ? form.slider.path : ''"
              :imgId="form.slider ? form.slider.id : ''"
              @fileSelected="sliderChange"
              fieldName="mainImgFile"
              :maxSize="maxSizeSlider"
              :reset="resetBoolean"
            />
          </section>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadingImage"
            :disabled="form.slider == ''"
            @click="handleSaveSlider"
          >
            Save
          </v-btn>
          <v-btn color="error" text @click="cancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, StoreData, DeleteData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      csrs: [],
      csrsTableHeaders: [],
      loadingDataTable: false,
      zero: 0,
      dialog: false,
      sliderDialog: false,
      form: {
        logo: "",
        slider: ""
      },
      maxSize: 0.512,
      maxSizeSlider: 1.024,
      headerBoolean: true,
      sliderBoolean: true,
      csrId: null,
      globalServerErrors: null,
      resetBoolean: false,
      loadingImage: false
    };
  },
  created() {
    this.busStopHeaders();
  },
  methods: {
    indexCsrs(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: "content/csrs", query })
        .then(res => {
          const { data } = res.data;
          this.csrs = data;
          this.loadingDataTable = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    busStopHeaders() {
      const headersList = [
        "Pic",
        "Name",
        "Category",
        "No of kids 1",
        "No of kids 2",
        "Add Slider",
        "Sliders",
        "Add Logo",
        "Logos",
        "Actions"
      ];
      this.csrsTableHeaders = TableHeaders(headersList);
    },
    logoChange(logo) {
      this.form.logo = logo.file;
      this.logoBoolean = false;
      this.resetBoolean = false;
    },
    sliderChange(slider) {
      this.form.slider = slider.file;
      this.sliderBoolean = false;
      this.resetBoolean = false;
    },
    passItem(item) {
      this.dialog = true;
      this.csrId = item.id;
    },
    passSlider(item) {
      this.sliderDialog = true;
      this.csrId = item.id;
    },
    handleSave() {
      this.dialog = true;
      this.loadingImage = true;
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `content/csrs/${this.csrId}/csr-logos`,
        data: formData
      })
        .then(() => {
          this.dialog = false;
          this.resetBoolean = true;
          this.loadingImage = false;
          this.form.logo = "";
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
        })
        .finally(() => {
          this.loadingImage = false;
        });
    },
    handleSaveSlider() {
      this.sliderDialog = true;
      this.loadingImage = true;
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `content/csrs/${this.csrId}/csr-sliders`,
        data: formData
      })
        .then(() => {
          this.sliderDialog = false;
          this.resetBoolean = true;
          this.loadingImage = false;
          this.form.slider = "";
          this.indexCsrs();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
        })
        .finally(() => {
          this.loadingImage = false;
        });
    },
    cancel() {
      this.dialog = false;
      this.sliderDialog = false;
      this.resetBoolean = true;
      this.form.logo = "";
      this.form.slider = "";
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/content/csrs`,
            id: id
          })
            .then(() => {
              this.csrs.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler() {
        this.indexCsrs();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
